import moment from 'moment'
import * as yup from 'yup'

const formatDateString = (date: string) => {
  return moment(`${date}`, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
}

export const painelNaturalPersonSchema = yup.object({
  cpf: yup
    .string()
    .test('incompleteField', 'Campo incompleto', (value) => {
      if (value) {
        return value.length >= 14
      }

      return true
    })
    .notRequired()
    .nullable(),
  name: yup
    .string()
    .test('invalidName', 'Nome inválido', (value) => {
      if (value) {
        const regex =
          /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u
        return regex.test(value)
      }

      return true
    })
    .notRequired()
    .nullable(),
  email: yup.string().email('Email inválido').required('Campo obrigatório'),
  birthdate: yup
    .string()
    .test('isValidDate', 'Data inválida', (value) => {
      if (value) {
        const formattedDate = formatDateString(value)
        return moment(formattedDate).isValid()
      }

      return true
    })
    .test('maxDate', 'Não é possível inserir uma data futura', (value) => {
      if (value) {
        const formattedDate = formatDateString(value)
        return moment(formattedDate).isBefore(moment().add(1, 'd'), 'day')
      }

      return true
    })
    .test('legalAgeDate', 'Deve ser maior de 18 anos', (value) => {
      if (value) {
        const eighteenYearsAgo = moment().subtract(18, 'years')
        return moment(value, 'DD/MM/YYYY').isSameOrBefore(
          eighteenYearsAgo,
          'day'
        )
      }

      return true
    })
    .notRequired()
    .nullable(),
  rg: yup
    .string()
    .test('invalidField', 'Campo inválido', (value) => {
      if (value) {
        const regex = /^[ 0-9a-zA-Z.\-\b]+$/
        return regex.test(value)
      }

      return true
    })
    .notRequired()
    .nullable(),
  phone: yup.string().notRequired().nullable(),
  linkedin: yup.string().notRequired().nullable(),
  cep: yup
    .string()
    .test('incompleteField', 'Campo incompleto', (value) => {
      if (value) {
        return value.length >= 9
      }

      return true
    })
    .notRequired()
    .nullable(),
  street: yup.string().notRequired().nullable(),
  complement: yup.string().notRequired().nullable(),
  city: yup.string().notRequired().nullable(),
  state: yup.string().notRequired().nullable(),
  neighborhood: yup.string().notRequired().nullable(),
  addressNumber: yup
    .string()
    .test('invalidNumber', 'Número inválido', (value) => {
      if (value) {
        const regex = /^[0-9]+$/
        return regex.test(value)
      }

      return true
    })
    .notRequired()
    .nullable(),
  researcherId: yup.string().notRequired().nullable(),
})
